import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/problem_selected.png';
import _imports_1 from '@/assets/no.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c0ba7970"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "container"
};
var _hoisted_2 = {
  "class": "IndexCardItem"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "icon",
    src: _imports_0
  }, null, -1);
});
var _hoisted_4 = {
  "class": "text"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 0,
  "class": "checked"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
import Activity from '@/common/components/Activity.vue';
import ScreenScrollView from '@/common/components/ScreenScroll/ScreenScrollView.vue';
import { useApiToState } from '@/common/util/useApiToState';
import { getApiFeedbackProblemInfo, postApiFeedbackProblemBehavior } from '@/service/api';
import { showSuccessToast } from 'vant';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
import { showImagePreview } from 'vant';
import { t } from '@/i18n';
var BehaviorType;
(function (BehaviorType) {
  BehaviorType[BehaviorType["Yes"] = 1] = "Yes";
  BehaviorType[BehaviorType["No"] = 2] = "No";
})(BehaviorType || (BehaviorType = {}));
var ActiveType;
(function (ActiveType) {
  ActiveType[ActiveType["Enter"] = 1] = "Enter";
  ActiveType[ActiveType["Cancel"] = 2] = "Cancel";
})(ActiveType || (ActiveType = {}));
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var contentRef = ref();
    var route = useRoute();
    var _useApiToState = useApiToState(function () {
        return getApiFeedbackProblemInfo({
          problemId: route.params.id,
          openId: window.openid
        });
      }),
      _useApiToState2 = _slicedToArray(_useApiToState, 4),
      item = _useApiToState2[0],
      handler = _useApiToState2[3];
    var handleSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(type) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return handler(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(item.value.behaviorType === type)) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return");
                    case 2:
                      _context.next = 4;
                      return postApiFeedbackProblemBehavior({
                        problemId: route.params.id,
                        openId: window.openid,
                        behaviorType: type,
                        active: ActiveType.Enter
                      });
                    case 4:
                      item.value.behaviorType = type;
                      showSuccessToast(t('OperationSuccessful'));
                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleSubmit(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var onContentClick = function onContentClick(event) {
      var target = event.target;
      var tagName = (target && target.tagName).toLowerCase();
      if (tagName === 'img' && contentRef.value) {
        var urls = [];
        var index = 0;
        var images = contentRef.value.getElementsByTagName('img');
        for (var i = 0; i < images.length; i++) {
          if (images[i].src) {
            urls.push(images[i].src);
            if (event.target.src === images[i].src) {
              index = urls.length - 1;
            }
          }
        }
        if (urls.length > 0) {
          showImagePreview({
            images: urls,
            startPosition: index
          });
        }
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "QaInfoView"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(ScreenScrollView, null, {
            "default": _withCtx(function () {
              return [_unref(item) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(item).name), 1)]), _createElementVNode("div", {
                "class": "content",
                innerHTML: _unref(item).content,
                onClick: onContentClick,
                ref: function ref(_value, _refs) {
                  _refs['contentRef'] = _value;
                  contentRef.value = _value;
                }
              }, null, 8, _hoisted_5), _unref(item).behaviorType !== BehaviorType.Yes && _unref(item).behaviorType !== BehaviorType.No ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
                "class": "item yes",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return handleSubmit(BehaviorType.Yes);
                })
              }, [_hoisted_7, _createElementVNode("p", null, _toDisplayString(_unref(t)('Helpful')), 1)]), _createElementVNode("div", {
                "class": "item",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return handleSubmit(BehaviorType.No);
                })
              }, [_hoisted_8, _createElementVNode("p", null, _toDisplayString(_unref(t)('NotHelpful')), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
});